const ToggleSwitch = ({ enabled, onToggle }) => {
  return (
    <div
      className={`relative w-10 h-6 rounded-full cursor-pointer transition ${
        enabled ? "bg-blue-500" : "bg-gray-300"
      }`}
      onClick={onToggle}
    >
      {/* Toggle circle */}
      <div
        className={`absolute w-4 h-4 rounded-full bg-white top-1 transition-transform ${
          enabled ? "translate-x-5" : "translate-x-1"
        }`}
      />
    </div>
  );
};
export default ToggleSwitch;
